import { render } from "./CheckboxInputSmall.vue?vue&type=template&id=2549d2b8&scoped=true"
import script from "./CheckboxInputSmall.vue?vue&type=script&lang=js"
export * from "./CheckboxInputSmall.vue?vue&type=script&lang=js"

import "./CheckboxInputSmall.vue?vue&type=style&index=0&id=2549d2b8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2549d2b8"]])

export default __exports__